import { render } from "./PolicyReviewAddOnboardComponent.vue?vue&type=template&id=65dc7798&scoped=true"
import script from "./PolicyReviewAddOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyReviewAddOnboardComponent.vue?vue&type=script&lang=js"

import "./PolicyReviewAddOnboardComponent.vue?vue&type=style&index=0&id=65dc7798&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dc7798"]])

export default __exports__